import api from '@pray/shared/utils/api';

import { buildDailyItemLocalesUrl } from './buildDailyItemLocalesUrl';
import type { DailyItemLocaleRef } from './types';

export async function deleteDailyItemLocale(ref: DailyItemLocaleRef, localeCode: string) {
  await api.executeDeleteRequest(`${buildDailyItemLocalesUrl(ref)}/${localeCode}`);

  return { success: true };
}
